module.exports = __webpack_public_path__ + "img/topbriefcase.9fb0d0f3.svg";